<template>
  <v-img
    v-if="settings?.bg_image"
    :src="isHotelSite ? bgImage : ''"
    :height="isMobile ? 'unset' : '100vh'"
  >
    <div
      class="listings-view"
      :style="{
        'padding-top': isAgentReserveSite ? '0' : siteExtendedHeaderHeight,
      }"
    >
      <site-header v-if="!isPortfolioSite" filters />
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        class="progress-bar"
      />
      <v-container fluid class="pa-0">
        <v-row no-gutters :class="{ 'd-flex justify-center': isHotelSite }">
          <v-col
            v-if="isHotelSite"
            cols="12"
            lg="3"
            :class="{
              'white rounded-lg pa-4 ma-4 pt-0 h-fit-content': isHotelSite,
            }"
          >
            <listing-hotel-filters is-hotel-site />
          </v-col>
          <v-col
            cols="12"
            lg="6"
            :class="{ 'white rounded-lg pa-4 ma-4 black--text': isHotelSite }"
          >
            <v-sheet v-if="!isHotelSite" class="d-flex justify-start pa-4">
              <listing-filters-bar />
            </v-sheet>
            <site-listings
              show-calculations
              :lg="isHotelSite ? 12 : 6"
              :carousel-lg="isHotelSite ? 4 : 12"
              :horizontal="isHotelSite"
              :class="
                isLargeLaptop || isDesktop || isMobileOrIPad
                  ? 'overflow-x-hidden overflow-y-auto'
                  : ''
              "
              :style="{
                height: isMobile
                  ? ''
                  : `calc(100vh - ${isAgentReserveSite ? 0 : 210}px)`,
              }"
              class="site-listings pa-2 ma-0 ml-sm-4 pr-sm-6 mt-2"
            />
          </v-col>
          <v-col v-if="!isHotelSite" cols="12" lg="6" class="d-none d-lg-block">
            <site-map />
          </v-col>
        </v-row>
      </v-container>
      <!-- <site-bottom-navigation v-if="isMobile" /> -->
      <!-- <site-footer /> -->
    </div>
  </v-img>
</template>

<script>
import DeviceMixin from "@/mixins/device-mixin";
import StylesMixin from "@/mixins/styles-mixin";
import SiteHeader from "@/components/header/site-header";
import SiteListings from "@/components/common/site-listings.vue";
import MediaMixin from "@/mixins/media-mixin";
import ListingHotelFilters from "@/components/listing/listing-hotel-filters.vue";
import ListingFiltersBar from "@/components/listing/listing-filters-bar.vue";
// import SiteFooter from "@/components/footer/site-footer";
import SiteMap from "@/views/site-map";
import { mapState } from "vuex";
// import SiteBottomNavigation from "@/components/footer/site-bottom-navigation";
export default {
  name: "listings-view",
  components: {
    SiteHeader,
    SiteListings,
    // SiteFooter,
    // SiteBottomNavigation,
    SiteMap,
    ListingHotelFilters,
    ListingFiltersBar,
  },
  mixins: [DeviceMixin, StylesMixin, MediaMixin],
  data() {
    return {
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
  computed: {
    ...mapState({
      loading: (state) => state.listingsModule.loading,
      pagination: (state) => state.listingsModule.pagination,
      settings: (state) => state.settingsModule.settings,
    }),
    bgImage() {
      console.log(this.settings);
      return this.isMobile
        ? this.settings?.bg_image?.replace("upload/", "upload/c_fill,ar_1:2/")
        : this.resize(this.settings?.bg_image, this.screenHeight);
    },
    isHotelSite() {
      return this.settings.site_type === "hotel" && !this.isMobile;
    },
    isAgentReserveSite() {
      return this.settings.site_type === "agent_reserve";
    },
    isPortfolioSite() {
      return this.isAgentReserveSite && !this.$route.query.agent_id;
    },
  },
};
</script>

<style lang="scss">
.h-fit-content {
  height: fit-content;
}
.listings-view {
  .v-toolbar__content,
  .v-toolbar__extension {
    z-index: auto;
  }
  .progress-bar {
    z-index: 1;
    position: fixed;
    width: 100%;
  }
}
</style>
